export async function updatePage (platform, page, selectedContentFramework) {
  if (!page || !page.title || !page.url) {
    window.alert('A page must have a title')
    return
  }

  try {
    // If page does not have UUID, we assume its a new page
    if (!page.id) {
      if (!page.url.startsWith('/')) {
        page.url = `/${page.url}`
      }

      if (page.url.endsWith('/' && page.url.length > 1)) {
        page.url = page.url.slice(0, -1)
      }

      if (!page.canonicalURL) {
        page.canonicalURL = page.url
      }

      const createdPage = await platform.api.cms.pages.create(page)

      const renderData = await platform.api.cms.pages.render(page.url)

      const branchLinks = {}

      const types = platform.api.core.template
      const { findNode } = platform.api.core.template

      if (createdPage.id && selectedContentFramework) {
        const page = JSON.parse(JSON.stringify(createdPage))
        const framework = JSON.parse(selectedContentFramework.payload)
        for (const nodeId in framework) {
          if (framework[nodeId].type === types.ROW_BRANCH) {
            branchLinks[nodeId] = framework[nodeId].blockId

            delete framework[nodeId]
          }
        }

        while (Object.keys(framework).length) {
          for (const nodeId in framework) {
            for (const nodeId in branchLinks) {
              const res = findNode(renderData, nodeId)
              const node = res

              if (!node) {
                continue
              }

              const blockId = branchLinks[nodeId]

              let data = await platform.api.cms.pages.render(page.url, blockId)

              platform.store.update(store => {
                store.render = data

                return store
              })

              platform.api.cms.actions.nodeSetPageBranchBlock({
                nodeId,
                blockId: branchLinks[nodeId],
                newRenderData: data,
              })

              data = platform.storeData.render

              renderData.branches[blockId] = data.layout.block
              renderData.branches = { ...renderData.branches, ...data.branches }
              renderData.links = { ...renderData.links, ...data.links }
              renderData.blocks = { ...renderData.blocks, ...data.blocks }

              delete branchLinks[nodeId]
            }

            framework[nodeId].attempts = framework[nodeId].attempts || 0
            ++framework[nodeId].attempts

            if (framework[nodeId].attempts > 100) {
              delete framework[nodeId]

              continue
            }

            const res = findNode(renderData, nodeId)
            const node = res

            if (!node) {
              continue
            }

            const blockId = renderData.links[node.id]
            const block = platform.api.core.template.findBlock(renderData, blockId)

            if (block && block.nodes && block.nodes.length) {
              continue
            }

            const defaultNodes = framework[nodeId]

            let index = 0

            delete defaultNodes.attempts

            for (let i = 0; i < defaultNodes.length; ++i) {
              const defaultNode = defaultNodes[i]

              switch (defaultNode.type) {
                case types.PLUGIN: {
                  const pluginId = platform.api.core.uuid()

                  platform.store.update(store => {
                    store.editor.actions.push({
                      name: 'PLUGIN_CREATE',
                      meta: {
                        pluginId,
                        ref: defaultNode.ref,
                        fields: {},
                        isExisting: false,
                      },
                    })
                    store.editor.actions.push({
                      name: 'BLOCK_ADD_PLUGIN_NODE',
                      meta: {
                        blockId,
                        nodeId: platform.api.core.uuid(),
                        pluginId,
                        index,
                      },
                    })
                    return store
                  })
                  ++index

                  break
                }
              }
            }

            delete framework[nodeId]
          }
        }

        for (const nodeId in branchLinks) {
          const res = findNode(renderData, nodeId)
          const node = res

          if (!node) {
            continue
          }

          const blockId = branchLinks[nodeId]
          const data = await platform.api.cms.pages.render(createdPage.url, blockId)

          delete data.layout

          platform.api.cms.actions.nodeSetPageBranchBlock({
            nodeId,
            blockId,
            newRenderData: data,
          })

          delete branchLinks[nodeId]
        }

        await platform.api.cms.commands.saveActions(createdPage.id, platform.storeData.editor.actions)

        platform.store.update(store => {
          store.editor.actions = []
          return store
        })
      }
      return createdPage
    } else {
      await platform.api.cms.pages.update(page)
    }
  } catch (err) {
    console.error(err)
  }
}
